import React, { FC } from 'react';
import { Row } from 'react-table';
import { IUser } from 'modules/core/types';
import { useSelector } from 'react-redux';
import { getUser } from 'store/selectors/auth.selector';
import { userHasInventory } from 'modules/core/utils';

import { canRenderRow } from '../helper';
import { TABLE_RENDER_CELL_KEY } from '../table.const';
import { TableCell, TableRow } from '../styles';
import { RAC_VEHICLE_TABLE_COLUMN_ID } from '../../VehicleTable/defaultVehicleTableColumns';

export interface ITableRow {
  rows: Row[];
  additionalRows: Row[];
  prepareRow: (row: Row) => void;
  pageSize: number;
  currentPage: number;
  isServerPagination?: boolean;
  handleOpenDialog?: () => void;
  isMakeItWork: boolean;
  dealSourceVehicleRowIndex: number;
  isRac?: boolean;
  isLender?: boolean;
}

export const TableBody: FC<ITableRow> = ({
  rows,
  additionalRows,
  prepareRow,
  pageSize,
  currentPage,
  isServerPagination = false,
  handleOpenDialog,
  isMakeItWork,
  dealSourceVehicleRowIndex,
  isRac,
  isLender = false,
}) => {
  const user = useSelector(getUser) as IUser;
  const specialColumns = [
    RAC_VEHICLE_TABLE_COLUMN_ID.PHOTO,
    RAC_VEHICLE_TABLE_COLUMN_ID.VIN,
    RAC_VEHICLE_TABLE_COLUMN_ID.STOCK,
  ];

  return (
    <tbody>
      {rows.map((row, item) => {
        prepareRow(row);

        return canRenderRow(item, pageSize, currentPage, isServerPagination) ? (
          <TableRow
            isMakeItWork={isMakeItWork}
            isMakeItWorkVehicle={row.index === dealSourceVehicleRowIndex}
            isRac={isRac}
            isLender={isLender}
            {...row.getRowProps()}
            onClick={handleOpenDialog}
          >
            {row.cells.map(({ getCellProps, render, column }) => (
              <TableCell
                {...getCellProps()}
                isRac={isRac}
                isSpecialColumn={specialColumns.includes(column.id)}
                isLender={isLender}
              >
                {render(TABLE_RENDER_CELL_KEY)}
              </TableCell>
            ))}
          </TableRow>
        ) : null;
      })}
      {additionalRows.map((row) => {
        prepareRow(row);

        return !userHasInventory(user) ? (
          <TableRow isBlur isRac={isRac} {...row.getRowProps()}>
            {row.cells.map(({ getCellProps, render, column }) => (
              <TableCell {...getCellProps()} isRac={isRac} isSpecialColumn={specialColumns.includes(column.id)} isBlur>
                {render(TABLE_RENDER_CELL_KEY)}
              </TableCell>
            ))}
          </TableRow>
        ) : null;
      })}
    </tbody>
  );
};
